import { render } from "./FileUploader.vue?vue&type=template&id=a15c207c&ts=true"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"

import "./FileUploader.vue?vue&type=style&index=0&id=a15c207c&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__